import ko from "knockout";
import _ from "lodash";
import ServiceResponseValidator from "util/ServiceResponseValidator";

function buildInvalidEvaluatorMessage(response, value, messageParamProperty) {
    let invalidEvaluator = value;
    if (_.isArray(value)) {
        if (
            response.messageParams &&
            response.messageParams[messageParamProperty]
        ) {
            invalidEvaluator = _.find(value, {
                id: response.messageParams[messageParamProperty],
            });
        }
    }

    const result = {};
    if (invalidEvaluator && invalidEvaluator.name) {
        result.message = ko.i18n.renderString(
            "evaluation.evaluatorsCantScore",
            {
                value: invalidEvaluator.name,
            }
        );
    } else {
        result.message = ko.i18n.renderString("evaluation.evaluatorCantScore");
    }
    return result;
}

export default function () {
    return new ServiceResponseValidator({
        "quality.evaluation.evaluator.not.quality.evaluator": function (
            response,
            value
        ) {
            return buildInvalidEvaluatorMessage(response, value, "evaluatorId");
        },
        "quality.calibration.expert.evaluator.not.quality.evaluator": function (
            response,
            value
        ) {
            return buildInvalidEvaluatorMessage(
                response,
                value,
                "expertEvaluatorId"
            );
        },
    });
}
